import HlsSubtitles from './hls-subtitles';
import SVPCustomEvent from '../../util/custom-event';

export default class HlsJsSubtitles extends HlsSubtitles {
    constructor(hlsJsObject, videoElement, api, Hls) {
        super(videoElement, api);

        this.hlsJsObject = hlsJsObject;
        this.hlsJsObject.subtitleDisplay = false;

        /**
         * Edge does not support change event on TextTrackList. The following
         * is a workaround to trigger the event. Hls.js will trigger SUBTITLE_TRACK_SWITCH
         * before setting text track mode. A timeout is required to wait for the mode to
         * be set.
         */
        if (!this.videoElement.textTracks.onchange) {
            this.hlsJsObject.on(Hls.Events.SUBTITLE_TRACK_SWITCH, () => {
                window.setTimeout(() => {
                    const ev = new SVPCustomEvent('change');
                    this.videoElement.textTracks.dispatchEvent(ev);
                }, 0);
            });
        }
    }

    show() {
        this.hlsJsObject.subtitleTrack = 0;
    }

    hide() {
        this.hlsJsObject.subtitleTrack = -1;
    }
}



// WEBPACK FOOTER //
// ./src/js/modules/hls/hls-js-subtitles.js